/**
 * Single source of truth for company facts.
 * Every page, ticker, and footer must read from here. Never hardcode
 * years, counts, or contact details in components.
 */

// Display brand, not the registered entity name: if the business ever supplies a
// legal name ("... Limited"), that becomes a separate constant. Declared first
// because waLink below builds on it.
export const BRAND = "Le-Paz Advisory Africa";
export const FORMER_NAME = "Le-Paz Insurance Agency";

export const FOUNDED_YEAR = 2012;

// Derived so "N years" copy stays true every January without edits.
export const YEARS = new Date().getFullYear() - FOUNDED_YEAR;

export const FOUNDER_START_YEAR = 2011;
export const FOUNDER_YEARS = new Date().getFullYear() - FOUNDER_START_YEAR;
export const FOUNDER_MDRT_COUNT = 3;
export const FOUNDER_DIAMOND_COUNT = 4;

export const CLIENTS = 2400;
export const CLAIMS_RATE = 98;

export const PHONE = "+254 799 150 990";
export const PHONE_WA = "254799150990"; // wa.me format: country code, no + or spaces

// Callers pass only what they are asking for; the greeting is added here so every
// prefilled chat opens the same way.
export const waLink = (ask, phone = PHONE_WA) =>
  `https://wa.me/${phone}?text=${encodeURIComponent(`Hi ${BRAND}, ${ask}`)}`;
// Generic WhatsApp deep link used by the site-wide "Get a Quote" CTAs.
export const QUOTE_HREF = waLink("I'd like a quote.");
export const EMAIL = "info@lepazadvisoryafrica.co.ke";
export const ADDRESS = "Titan Complex, Chaka Road, Kilimani, Nairobi";

// Insurance Regulatory Authority licence number, awaiting the real number.
// Badge copy renders without the number until this is set.
export const IRA_LICENSE = null;

export const SITE_URL = "https://www.lepazadvisoryafrica.co.ke";

export const TAGLINE = "Insurance you actually understand.";
export const TAGLINE_ALT = "Independent Insurance & Wealth Advice";
